export function exitInterviewFormForDialog(emptyForm, exitInterview, selectedClassProgram) {
  const saved = Boolean(exitInterview?.id);
  return {
    ...emptyForm,
    ...(exitInterview || {}),
    exit_interview_program: saved
      ? (exitInterview.exit_interview_program ?? '')
      : (exitInterview?.exit_interview_program || selectedClassProgram || '')
  };
}
